export default function ({ isHMR }) {
  // eslint-disable-next-line
  if (isHMR) { return; }
}
